module.exports = __webpack_public_path__ + "static/logo-82b168e7c3bd958bdad0d1be987da956.png";